import { createLogger, ILogger } from "@ir/core/logger/decorator";

export enum WIPFlags {
  DEDUCTION_FILTER_ADJUSTMENT = "DEDUCTION_FILTER_ADJUSTMENT",
  DEDUCTION_FILTER_DATE_PRESET = "DEDUCTION_FILTER_DATE_PRESET",
  INTELLI_UPLOAD_PROCESS_BUTTON = "INTELLI_UPLOAD_PROCESS_BUTTON",
  PROMO_MATCH_VIEW = "PROMO_MATCH_VIEW",
  ANALYTICS_SHARE = "ANALYTICS_SHARE",
  ACCOUNTING_CHECK_GROUPED_QUEUE = "ACCOUNTING_CHECK_GROUPED_QUEUE",
  DISPUTE_TRACKING = "DISPUTE_TRACKING",
}

type FlagRecord = Record<WIPFlags, boolean>;

const VITE_FLAG_PREFIX = "VITE_FLAG_";

class FlagsConfig {
  private static _instance: FlagsConfig | null = null;
  private readonly _workInProgressFlags: FlagRecord;
  private readonly logger: ILogger = createLogger("FlagsConfig");
  private constructor() {
    this._workInProgressFlags = this.initializeFlags();
  }

  private initializeFlags(): FlagRecord {
    const flags: Partial<FlagRecord> = {};
    const envVars = import.meta.env;

    // Initialize all flags to false by default
    for (const flag of Object.values(WIPFlags)) {
      flags[flag] = false;
    }

    // Update flags based on environment variables
    for (const [key, value] of Object.entries(envVars)) {
      if (!key.startsWith(VITE_FLAG_PREFIX)) {
        continue;
      }

      try {
        const flagName = key.replace(VITE_FLAG_PREFIX, "");
        const flag = WIPFlags[flagName as keyof typeof WIPFlags];

        if (flag) {
          flags[flag] = value === "true";
        }
      } catch (error) {
        this.logger.warn(`Invalid flag configuration for ${key}:`, error);
      }
    }

    return flags as FlagRecord;
  }

  public static getInstance(): FlagsConfig {
    FlagsConfig._instance ??= new FlagsConfig();
    return FlagsConfig._instance;
  }

  public getFlag(flag: WIPFlags): boolean {
    return this._workInProgressFlags[flag] ?? false;
  }
}

export const FlagsConfigInstance = FlagsConfig.getInstance();
